import { Button, Card, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import useScript from "../../hooks/useUrlScript";

type Props = {};

const RegistrationSuccessfull = (props: Props) => {
  const navigate = useNavigate();
  const scriptUrlGoogle = "https://www.googletagmanager.com/gtag/js?id=G-MX2V75ZYNW";
  const googleScript = `window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-MX2V75ZYNW');`;
  const fbScriptUrl = "https://www.facebook.com/tr?id=2018761065188706&ev=PageView&noscript=1";
  const fbScriptPixel = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '2018761065188706');
fbq('track', 'PageView');
`;
  useScript(scriptUrlGoogle, googleScript);
  useScript(fbScriptUrl, fbScriptPixel);
  // useInlineScript(`window.lintrk('track', { conversion_id: 16880364 })`);

  return (
    <div className="success-page-wrap">
      <Container className="w-800">
        <Card bg="white" className="success-card">
          <Card.Body>
            <h1 className="fw-bold text-center mb-1">Registration Successful</h1>
            <div className="btn-wrap mt-5">
              <Button
                variant="primary"
                type="submit"
                size="lg"
                className="w-100 shadow"
                onClick={() => navigate("/", { replace: true })}
              >
                Continue
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default RegistrationSuccessfull;
